import React, { useState } from "react";
import logo from "assets/images/logo.jpeg";

const NAV_LINKS = [
  { label: "Ana Sayfa", href: "https://lojgo.com/" },
  { label: "Hakkımızda", href: "https://lojgo.com/" },
  { label: "Blog", href: "https://lojgo.com/" },
  { label: "S.S.S", href: "https://lojgo.com/" },
  { label: "İletişim", href: "https://lojgo.com/" },
];

const AuthHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header
      style={{
        background: "#1a2634",
        color: "#fff",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 80,
        }}
      >
        {/* Logo */}
        <a href="https://lojgo.com/" style={{ textDecoration: "none" }}>
          <div
            style={{
              width: 120,
              height: 56,
              borderRadius: 14,
              overflow: "hidden",
              border: "2px solid #f15a24",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              transition: "transform 0.2s",
            }}
            onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
            onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
          >
            <img src={logo} alt="LojGo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        </a>

        {/* Masaüstü Nav */}
        <nav style={{ display: "flex", gap: 32, alignItems: "center" }} className="auth-header-nav">
          {NAV_LINKS.map(link => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#fff",
                textDecoration: "none",
                fontSize: 12,
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: "0.18em",
                transition: "color 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.color = "#f15a24"}
              onMouseLeave={e => e.currentTarget.style.color = "#fff"}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Mobil hamburger */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="auth-header-hamburger"
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            cursor: "pointer",
            padding: 8,
            display: "none",
          }}
        >
          <svg width="28" height="28" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isOpen ? (
              <path d="M6 18L18 6M6 6l12 12" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" />
            ) : (
              <path d="M4 6h16M4 12h16m-7 6h7" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobil Menü */}
      {isOpen && (
        <div
          style={{
            background: "#1a2634",
            borderTop: "1px solid rgba(255,255,255,0.05)",
            padding: "20px 24px 28px",
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          {NAV_LINKS.map(link => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              style={{
                color: "#fff",
                textDecoration: "none",
                fontSize: 12,
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: "0.18em",
                paddingBottom: 16,
                borderBottom: "1px solid rgba(255,255,255,0.05)",
              }}
            >
              {link.label}
            </a>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 900px) {
          .auth-header-nav { display: none !important; }
          .auth-header-hamburger { display: flex !important; }
        }
      `}</style>
    </header>
  );
};

export default AuthHeader;
